import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_CONVERSTAION, EDIT_CONVERSTAION, CREATE_CONVERSTAION } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteConverstaion(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_CONVERSTAION}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editConverstaion(prevData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_CONVERSTAION}`, prevData, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createConverstaion(prevData, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_CONVERSTAION}`, prevData, configReq(token));
}
